import Swiper from 'swiper';

// Swiper Image Gallery slider
const init = function(swiperId) {
  const imageGallerySwiper = new Swiper(swiperId, {
    loop: true,
    speed: 1500,
    effect: 'fade',
    spaceBetween: 50,
    autoHeight: true,
    keyboard: {
      enabled: false,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  });
};

export default {
  init,
};
